"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Toggle", {
    enumerable: true,
    get: function() {
        return Toggle;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
var _icon = require("../Icon");
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Toggle = /*#__PURE__*/ _react.default.forwardRef(function(props, ref) {
    var className = props.className, disabled = props.disabled, onToggle = props.onToggle, onChange = props.onChange, defaultChecked = props.defaultChecked, name = props.name, hasError = props.hasError, title = props.title, rest = _objectWithoutProperties(props, [
        "className",
        "disabled",
        "onToggle",
        "onChange",
        "defaultChecked",
        "name",
        "hasError",
        "title"
    ]);
    var _useState = _slicedToArray((0, _react.useState)(defaultChecked), 2), localChecked = _useState[0], setLocalChecked = _useState[1];
    var checked = props.checked !== undefined ? props.checked : localChecked;
    var classes = {
        body: (0, _classnames.default)("relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent-500", className, {
            "bg-gray-200": !checked || disabled
        }, {
            "bg-accent-600": checked
        }, {
            "bg-red-100 border-red-500 ": !disabled && hasError
        }),
        switch: (0, _classnames.default)("absolute pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200", {
            "translate-x-0": !checked || disabled
        }, {
            "translate-x-5": checked
        }),
        check: (0, _classnames.default)(" block m-auto", {
            "text-accent-600": !disabled,
            "text-gray-400": disabled
        })
    };
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: classes.body
    }, /*#__PURE__*/ _react.default.createElement("label", {
        className: "cursor-pointer block h-6 w-11",
        title: title
    }, /*#__PURE__*/ _react.default.createElement("input", _extends({
        ref: ref,
        type: "checkbox",
        role: "switch",
        checked: checked,
        onChange: function(ev) {
            setLocalChecked(!!ev.target.checked);
            onChange && onChange(ev);
            onToggle && onToggle(!!ev.target.checked);
        },
        disabled: disabled,
        name: name,
        className: "hidden"
    }, rest)), /*#__PURE__*/ _react.default.createElement("span", {
        "aria-hidden": "true",
        className: classes.switch
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: "flex align-center h-5 w-5"
    }, checked ? /*#__PURE__*/ _react.default.createElement(_icon.CheckSmaller, {
        className: classes.check,
        title: "Toggle on"
    }) : /*#__PURE__*/ _react.default.createElement(_icon.Close, {
        className: "h-2 w-2 text-gray-400 block m-auto",
        title: "Toggle off"
    })))));
});
Toggle.displayName = "Toggle";

//# sourceMappingURL=Toggle.js.map